import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_router_link = _resolveComponent("router-link")

  return ($props.enabled)
    ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({ key: 0 }, _ctx.$attrs, {
        to: $options.toWithReturnPath,
        class: $options.linkClass,
        disabled: !$props.enabled,
        onClick: $options.onClick
      }), {
        default: _withCtx(() => [
          ($props.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(_component_base_icon, { name: $props.icon }, null, 8 /* PROPS */, ["name"]),
                _cache[0] || (_cache[0] = _createTextVNode(" ", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 16 /* FULL_PROPS */, ["to", "class", "disabled", "onClick"]))
    : (_openBlock(), _createElementBlock("span", _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)), [
        _renderSlot(_ctx.$slots, "default")
      ], 16 /* FULL_PROPS */))
}